<template>
  <div class="icon-selector">
    <CompactFilterBar shell-class="mb-3 rounded-xl border border-slate-200 bg-slate-50/70" body-class="p-3">
      <div class="filter-bar-field-sm relative">
        <svg class="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
        </svg>
        <input
          v-model="searchText"
          type="text"
          class="form-search-input form-control-sm w-full"
          placeholder="搜索图标..."
        >
      </div>
    </CompactFilterBar>

    <div class="icon-grid">
      <div
        v-for="icon in filteredIcons"
        :key="icon.name"
        class="icon-item"
        :class="{ active: modelValue === icon.name }"
        @click="selectIcon(icon.name)"
      >
        <component :is="icon.component" class="w-5 h-5" />
      </div>
    </div>

    <div v-if="filteredIcons.length === 0" class="py-4 text-center text-sm text-slate-400">
      没有找到匹配的图标
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import * as HeroIcons from '@heroicons/vue/24/outline'
import CompactFilterBar from '@/components/CompactFilterBar.vue'

defineProps({
  modelValue: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue'])

const searchText = ref('')

const iconList = Object.keys(HeroIcons).map(name => ({
  name: name.replace(/Icon$/, '').replace(/([A-Z])/g, '-$1').toLowerCase().replace(/^-/, ''),
  component: HeroIcons[name]
}))

const filteredIcons = computed(() => {
  if (!searchText.value) return iconList
  const lower = searchText.value.toLowerCase()
  return iconList.filter(icon => icon.name.toLowerCase().includes(lower))
})

function selectIcon(iconName) {
  emit('update:modelValue', iconName)
}
</script>

<style scoped>
.icon-selector {
  max-height: 300px;
  overflow-y: auto;
}

.icon-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 8px;
}

.icon-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  color: #64748b;
}

.icon-item:hover {
  border-color: #3b82f6;
  background-color: #eff6ff;
  color: #3b82f6;
}

.icon-item.active {
  border-color: #3b82f6;
  background-color: #3b82f6;
  color: white;
}
</style>
